import React, { Component } from 'react';
import Box from '../../components/Box';
import MBike from '../../models/MBike';
import { YesNo } from '../../modules/Helper';
import { BtnView, BikeUndeleteBtn } from '../../components/Btn';
import { Datatable } from '../../components/Datatable';
import { Modal } from '../../components/Modal';
import { BikeView } from './BikeView';
import { GetModal, ShowModal } from '../../modules/Event';
import { Link } from 'react-router-dom';
class DeletedBikes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: null,
      modalId: 'mdl-bikes-form',
      modalOpened: false,
      editData: null,
      viewModalId: 'mdl-bikes-view',
      viewModalOpened: false,
      viewData: null,
    };
  }
  renderData() {
    MBike.DeletedBikes()
      .done(resp => {
        resp = Array.isArray(resp) ? resp : [resp];
        this.setState({
          loading: false,
          data: resp,
        });
      })
      .catch(xhr => {
        this.setState({
          loading: false,
          data: [],
        });
      });
  }
  componentDidMount() {
    const { modalId, viewModalId } = this.state;
    this.renderData();
    GetModal(modalId).on('hidden.bs.modal', () => {
      this.setState({ modalOpened: false });
    });
    GetModal(viewModalId).on('hidden.bs.modal', () => {
      this.setState({ viewModalOpened: false, viewData: null });
    });
  }
  componentWillReceiveProps(nextProps) {
    //url query changes
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        loading: true,
      });
      this.renderData();
    }
  }

  viewItem(ev, id) {
    ev.preventDefault();
    const { viewModalId } = this.state;
    const elBtn = $(ev.target);
    elBtn.addClass('loading');
    MBike.get(id)
      .done(resp => {
        this.setState({
          viewModalOpened: true,
          viewData: resp,
        });
        elBtn.removeClass('loading');
        ShowModal(viewModalId);
      })
      .catch(xhr => {
        elBtn.removeClass('loading');
        alert(
          'Edit error #' + id + '.' + xhr.getResponseHeader('X-TBMS-Message'),
        );
      });
  }

  UndeleteBike(ev, id) {
    ev.preventDefault();
    if (!window.confirm('Are you sure you want to Undelete Bike?')) {
      return false;
    } else {
      var formData = { id: id, is_hidden: false };
      MBike.update(formData)
        .done(resp => {
          this.renderData();
        })
        .catch(xhr => this.catchError(xhr));
    }
  }

  render() {
    const {
      loading,
      data,
      viewModalId,
      viewModalOpened,
      viewData,
    } = this.state;
    const thead = [
      'Number Plate',
      'Odometer(km)',
      'Type',
      'Ready for Hire ?',
      'Bikes Current Location',
      'Action',
    ];
    return [
      <Box key="0" title="Deleted Bikes">
        <Datatable loading={loading} thead={thead}>
          {data != null &&
            !loading &&
            data.map((item, idx) => {
              const {
                id,
                numberplate,
                odometer_x10,
                manufacturer_name,
                model_name,
                engine_capacity,
                transmission_name,
                ready_for_hire,
                location_name,
              } = item;
              return (
                <tr key={idx} id={'dt-item-' + id}>
                  <td>
                    <Link to={'/bike-checkins?f-numberplate=' + numberplate}>
                      {' '}
                      {numberplate}{' '}
                    </Link>
                  </td>
                  <td>{odometer_x10}</td>
                  <td>
                    {manufacturer_name} {model_name} {engine_capacity}cc -{' '}
                    {transmission_name}
                  </td>

                  <td>{YesNo(ready_for_hire)}</td>
                  <td>{location_name}</td>
                  <td className="box-action" style={{ width: 150 }}>
                    <BtnView clickHandler={e => this.viewItem(e, id)} />
                    <BikeUndeleteBtn
                      clickHandler={e => this.UndeleteBike(e, id)}
                    />
                  </td>
                </tr>
              );
            })}
        </Datatable>
      </Box>,
      <Modal
        key="2"
        id={viewModalId}
        title={viewData != null ? 'View Bike #' + viewData.id : ''}
        size="md"
      >
        {viewModalOpened && <BikeView data={viewData} />}
      </Modal>,
    ];
  }
}
export default DeletedBikes;
